<template>
	<section class="row mt-3" v-loading="loadings.main" style="width: 100%">
		<div class="col-md-2" v-for="key in fields" :key="key.name">
			<dl class="sum-box">
				<dt class="mr-3">{{key.title}}</dt>
				<dd>
					<el-tooltip :content="''+sumData[key.name]">
						<span>
							<span v-if="key.prefix">{{key.prefix}}</span>
							<span class="text-bold">{{sumData[key.name] | toChineseNum}}</span>
							<span v-if="key.postfix">{{key.postfix}}</span>
						</span>
					</el-tooltip>
				</dd>
			</dl>
		</div>
	</section>
</template>

<script>
export default {
	data() {
		return {
			loadings: {
				main: false
			},
			hasGetData: false,
			sumData: []
		};
	},
	props: {
		dataModel: {
			type: String,
			default: ""
		},
		kvFilter: {
			type: Object,
			default: function() {
				return {};
			}
		},
		fields: {
			type: Array,
			default: function() {
				return [];
			}
		},
		listUrl: {
			type: String,
			default: ""
		},
		searchFilter: {
			type: String,
			default: ""
		},
		dateFilter: {
			type: Array
		},
		warehouseFilter: {
			type: Object,
			default: function() {
				return {
					_id: ""
				};
			}
		}
	},
	computed: {},
	created() {},
	mounted() {
		this.refreshData();
	},
	methods: {
		refreshData() {
			this.loadings.main = true;
			const url = this.listUrl ? "/" + this.listUrl : `/curd/sum_count/${this.dataModel}`;
			this.$axios
				.post(url, {
					searchFilter: this.searchFilter,
					dateFilter: this.dateFilter,
					kvFilter: this.kvFilter,
					warehouseFilter: this.warehouseFilter._id,
					sumFields: this.fields.map(val => {
						return val.name.substr(val.name.indexOf("sum_") == "-1" ? 0 : 4);
					})
				})
				.then(json => {
					this.loadings.main = false;
					this.sumData = {};

					for (let k in json.data.sums) {
						this.$set(this.sumData, k, json.data.sums[k]);
					}
					for (let k in this.fields) {
						if (!this.sumData[this.fields[k].name]) {
							this.$set(this.sumData, this.fields[k].name, 0);
						}
					}
				})
				.catch(json => {
					this.loadings.main = false;
				});
		}
	},
	watch: {
		kvFilter: {
			handler(val) {
				if (val) {
					this.refreshData();
				}
			},
			immediate: false,
			deep: true
		},
		searchFilter: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					this.refreshData();
				}
			},
			immediate: false
		},
		dateFilter: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					this.refreshData();
				}
			},
			immediate: false
		},
		warehouseFilter: {
			handler(newVal, oldVal) {
				if (newVal != oldVal) {
					this.refreshData();
				}
			},
			immediate: false
		}
	}
};
</script>
